<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="loaded"
        >
            <rkm-area
                type="fieldset"
                title="Exportar"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.mesesAno"
                            label="Competência"
                            show-default-option
                            text-field="text"
                            v-model="model.mesAno"
                            value-field='value'
                            :validations="validations.mesAno"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="iniciarExportacao"
                        >
                            Exportar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Arquivos para downloads"
                show-legend
            >

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.competencia"
                            label="Competência"
                            show-default-option
                            text-field="text"
                            v-model="model.competencia"
                            value-field='value'
                            :validations="validations.competencia"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="arquivos"
                        >
                            Buscar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-table
                    :fields="fieldsDownloads"
                    :items="itemsDownloads"
                    sort-by="data"
                    ref="TableEsusArquivo"
                >

                    <template v-slot:cell(data)="{ item }">
                        {{ item.data }} às {{ item.horario }}
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click="handleDownload(item)"
                            color="primary"
                            small
                            title="Download"
                        >
                            <rkm-icon icon="download" />
                        </rkm-button>

                        <rkm-button
                            @click="handleDestroy(item)"
                            authorize="destroy-atencao-basica-exportacao"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>

            <rkm-area
                type="fieldset"
                title="Arquivos exportados"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.mesesAno"
                            label="Competência"
                            show-default-option
                            text-field="text"
                            v-model="buscaMesAno"
                            value-field='value'
                            :validations="validations.mesAno"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="exportacoes"
                        >
                            Buscar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>

                <rkm-table
                    :fields="fields"
                    :items="items"
                    sort-by="data"
                    ref="Table"
                >

                    <template v-slot:cell(data)="{ item }">
                        {{ item.data }} às {{ item.horario }}
                    </template>

                    <template v-slot:cell(actions)="{ item }">
                        <rkm-button
                            @click="$refs.Modal.open(item)"
                            title="Registros"
                            color="primary"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
        </rkm-form>

        <Modal
            ref="Modal"
            :model="model"
            :form="form"
        />
    </div>
</template>

<script>

import Modal from '@/components/atencao-basica/exportacao/Modal'

// Mixins
import { repository, stringCase, data, object, formats, error } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

export default {
    components: {
        Modal
    },
    computed: {
        validations() {
            return {
                mesAno: { required: true },
            }
        },
        items() {
            return this.form.exportacao ?? []
        }
    },
    created() {

        this.repositories = {
            exportacao: this.getConectaSusRepository('atencaoBasica.exportacao')
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        buscaMesAno: null,
        loaded: false,
        itemsDownloads: [],
        fields: [
            {
                key: 'data',
                label: 'Data da exportação',
                sortable: true,
                searchable: true,
            },
            {
                key: 'usuario',
                label: 'Profissional da exportação',
                sortable: true,
                searchable: true,
            },
            {
                key: 'uuid',
                label: 'UUID',
                sortable: true,
                searchable: true,
            },
            {
                key: 'funcionalidade',
                label: 'Funcionalidade',
                sortable: true,
                searchable: true,
            },
            {
                key: 'quantidade',
                label: 'Quantidade de registro(s)',
                sortable: true,
                searchable: true,
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        fieldsDownloads: [
            {
                key: 'data',
                label: 'Data da exportação',
                sortable: true,
                searchable: true,
            },
            {
                key: 'arquivo',
                label: 'Nome do arquivo',
                sortable: true,
                searchable: true,
            },
            {
                key: 'usuario',
                label: 'Profissional da exportação',
                sortable: true,
                searchable: true,
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min text-center'
            },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

                this.repositories.exportacao.create()
                    .then(response => {

                        this.model = Object.assign(response.data.model)
                        this.form = Object.assign(response.data.form)
                        this.loaded = true
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
        },
        iniciarExportacao() {

            this.continuarSistema();

        },
        download(loadingAtivo) {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (loadingAtivo) {

                        this.setLoading();
                    }

                        this.repositories.exportacao.download(this.prepareData())
                            .then(response => {

                                if (response.headers['content-disposition']) {

                                    let file = response.headers['content-disposition'].split('filename=')[1]
                                    file = file.replace('_inconsistente', '');

                                    const blob = new Blob([response.data], {type: response.headers['content-type']})
                                    const link = document.createElement('a')
                                    link.href = URL.createObjectURL(blob)
                                    link.download = file
                                    link.click()
                                    this.$nextTick().then(() => this.exportWithFile())
                                } else {

                                    this.$nextTick().then(() => this.exportWithoutFile())
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => {
                                if (loadingAtivo) {
                                    this.unsetLoading();
                                }
                            });
                })
        },
        continuarSistema() {

            const continuar = async () => {
                this.download(false);
            }

            const aguardar = async () => {
                this.download(true);
            }

            const msg = 'Você pode continuar usando o sistema sem perder o progresso da sua exportação.' +
                ' Deseja continuar ou aguardar a finalização?';

            this.showContinue(
                msg,
                continuar,
                aguardar,
                'Continuar no sistema',
                'Aguardar exportação'
            );
        },
        exportacoes() {

            this.setLoading()

            this.repositories.exportacao.getExportacoes(this.prepareDataBusca())
                .then(({ data }) => {

                    this.form.exportacao = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        arquivos() {

            this.setLoading()

            this.repositories.exportacao.getArquivos(this.prepareDataArquivos())
                .then(({ data }) => {

                    this.itemsDownloads = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        handleDownload(item) {

            this.repositories.exportacao.downloadArquivo(item.id)
                .then(response => {
                    console.log(response)
                    const file = response.headers['content-disposition'].split('filename=')[1]
                    const blob = new Blob([response.data])
                    const link = document.createElement('a')

                    link.href = URL.createObjectURL(blob)
                    link.download = file
                    link.click()
                })
                .catch(this.handleError)
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.exportacao.destroy(item.id)
                .then(() => {
                    this.itemsDownloads = this.itemsDownloads.filter(i => i.id !== item.id)
                })

            this.showDeleteConfirmation('Deseja realmente excluir o arquivo?', destroy, this.handleError)
        },
        exportWithFile() {

            this.setLoading()

            this.repositories.exportacao.getFichaVacinacao(this.prepareDataBusca())
                .then(response => {

                    if (response.data) {

                        this.showAlert(`Exportação concluída com sucesso! As fichas de vacinação não foram exportadas
                        manualmente, pois seu envio é realizado automaticamente por meio da integração com o
                        RIA.`, 'Atenção')
                    } else {

                        this.showSaveNotification('Exportação realizada com sucesso!')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        exportWithoutFile() {

            this.setLoading()

            this.repositories.exportacao.getFichaVacinacao(this.prepareDataBusca())
                .then(response => {

                    if (response.data) {

                        this.showAlert(`Conforme Ofício Conjunto Circular nº 1/2025/SVSA/SAPS/SEIDIGI/MS, o envio de
                        dados de vacinação via Thrift foi descontinuado. O envio é automático utilizando
                        a integração RIA.`, 'Atenção - Envio Bloqueado')
                    } else {

                        this.showAlert('Não há nenhuma ficha disponível para ser exportada.', 'Atenção')
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        prepareData() {

            const mesAno = this.model.mesAno

            return this.camelObjectKeysToSnakeRecursive({
                mesAno
            })
        },
        prepareDataBusca() {

            const mesAno = this.buscaMesAno

            return this.camelObjectKeysToSnakeRecursive({
                mesAno
            })
        },
        prepareDataArquivos() {

            const competencia = this.model.competencia

            return this.camelObjectKeysToSnakeRecursive({
                competencia
            })
        },
    },
    mixins: [repository, stringCase, data, object, formats, error],
    props: {
        id: { type: [Number, String], default: null },
    }
}
</script>